import React from 'react';
import HeroCarouselCard from './HeroCarouselCard.jsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import './HeroCarouselCards.scss';
SwiperCore.use([Pagination]);

const HeroCarouselCards = ({ cards, context }) => {
    if (!cards || cards.length === 0) return null;

    const isDesktop = typeof window !== 'undefined' ? window.innerWidth >= 769 : false;

    return (
        <div className="hero-carousel-cards">
            <Swiper
                className="cards-container"
                slidesPerView={'auto'}
                spaceBetween={16}
                allowTouchMove={!isDesktop}
                enabled={!isDesktop}
                style={{ display: 'flex', alignItems: 'stretch' }}
            >
                {cards.map((card, index) => (
                    <SwiperSlide key={index} className="cards-slide" style={{ height: 'auto', display: 'flex' }}>
                        <HeroCarouselCard
                            card={card}
                            context={context}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default HeroCarouselCards;
